import { conditionActions } from 'apps/builder/store/reducers/entities/conditions'
import { guid } from '../../lib/utils'
export const { addCondition, deleteCondition, updateCondition } =
  conditionActions

export const createCondition = data => {
  return addCondition({
    ...data,
    id: guid(),
  })
}
